import type { GetFormConfigurationQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMemo } from 'react';
import type { CustomAttributeSchemaLookup } from 'src/pages/custom-datasources/update/types';

import { useGetFormConfiguration } from '@/hooks/queries';

export const createCustomAttributeSchemaLookup = (
  formConfigurationData: GetFormConfigurationQuery | undefined
): CustomAttributeSchemaLookup | undefined => {
  const schemaConfigurations: CustomAttributeSchemaLookup = {};
  const formConfigurations = formConfigurationData?.form_configuration;
  if (!formConfigurations) {
    return undefined;
  }
  for (const formConfig of formConfigurations) {
    if (formConfig.customAttributeSchema) {
      schemaConfigurations[formConfig.ParentType] =
        formConfig.customAttributeSchema;
    }
  }

  return schemaConfigurations;
};

export const useCustomAttributeLookup = () => {
  // Empty `parentTypes` => all forms (the data-layer applies no ParentType
  // filter when the array is empty), matching the legacy unscoped
  // `getFormConfiguration` query with its default `where: {}`.
  const { data: formConfigurationData, loading } = useGetFormConfiguration({
    queryArgs: { parentTypes: [] },
  });
  const customAttributeSchemaLookup = useMemo(
    () => createCustomAttributeSchemaLookup(formConfigurationData),
    [formConfigurationData]
  );

  return {
    customAttributeSchemaLookup,
    loading,
  };
};
